module.exports = __webpack_public_path__ + "static/mobile-device-id-reset-marathons-eedc77556d1bfbeec7c9b4bd4fe17c9c.gif";